export default "__VITE_ASSET__15ace85c__"